<template>
  <vs-row class="m-title mb-4">
    <vs-col style="position: relative">
      <h5><i class="dot"></i>{{ label }}</h5>
      <div style="position: absolute; top:0; right:0; bottom:0; display: flex; align-items: center;">
        <slot name="right"/>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'MTitle',
  props: {
    label: { type: String }
  }
}
</script>

<style scoped>

</style>
